import { render, staticRenderFns } from "./advertiseEdit.vue?vue&type=template&id=947f879a&scoped=true&"
import script from "./advertiseEdit.vue?vue&type=script&lang=js&"
export * from "./advertiseEdit.vue?vue&type=script&lang=js&"
import style0 from "./advertiseEdit.vue?vue&type=style&index=0&id=947f879a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "947f879a",
  null
  
)

export default component.exports